import classNames from 'classnames';
import React from 'react';
import type { DayButtonProps } from 'react-day-picker';
import { useDayPicker } from 'react-day-picker';
import Button from './Button';
import * as styles from './DayButton.module.scss';

const DayButton = ({
  disabled,
  onClick,
  children,
  modifiers,
}: DayButtonProps) => {
  const context = useDayPicker();

  return (
    <div
      className={classNames(
        styles.dayWrapper,
        context.dayPickerProps.mode && styles[context.dayPickerProps.mode],
        {
          [styles.selected]: modifiers.selected,
          [styles.first]: modifiers.first,
          [styles.last]: modifiers.last,
          [styles.disabled]: modifiers.disabled,
        },
      )}
    >
      <Button
        className={styles.day}
        onClick={!disabled ? onClick : undefined}
        size="small"
      >
        {children}
      </Button>
    </div>
  );
};

export default DayButton;
